// Polyfills for js features used in the Dashboard but not supported in some browsers (mainly IE).
import '@tim/argon-pro/src/polyfills';

// Vendor plugins.
Vue.use(require('vue-highlightjs'))
Vue.use(require('portal-vue').default)

// Specific config.
Vue.use(require('./config').default)

// Local plugins.
Vue.use(require('@trax/plugins/Auth').default)              // $auth
Vue.use(require('./components/PermissionsPlugin').default)  // $permissions
Vue.use(require('./components/NavigationPlugin').default)   // $navigation
Vue.use(require('./components/SidebarPlugin').default)      // $sidebar
Vue.use(require('./components/LoaderPlugin').default)       // $loader
Vue.use(require('@trax/plugins/XapiClient').default)        // $xapi
Vue.use(require('./pwa').default)                           // $pwa

// Global vars.
Vue.prototype.$baseURL = window.baseURL                     // $baseURL
Vue.prototype.$eventBus = new Vue();                        // $eventBus

// Vue instance.
import routing from './routing'
import i18n from './i18n'
import App from './App.vue'

new Vue({
    router: routing.router(),
    i18n,
    render: h => h(App)
}).$mount("#app")
